import React, { useEffect } from 'react';
import './index.css';
import ReactGA from 'react-ga4';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Layout from './components/Layout';
import Home from './components/Home';
import Solutions from './components/Solutions';
import Pricing from './components/Pricing';
import About from './components/About';
// import DocsRedirect from './components/DocsRedirect';
import RequestDemo from './components/Contact';

function App() {
  useEffect(() => {
    ReactGA.initialize('G-QWF119T2V1');
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/reports" element={<Home />} />
          <Route exact path="/solutions" element={<Solutions />} />
          <Route exact path="/platform" element={<Solutions />} />
          <Route exact path="/intelligence" element={<Solutions />} />
          <Route exact path="/pricing" element={<Pricing />} />
          <Route exact path="/about" element={<About />} />
          <Route path="/contact" element={<RequestDemo />} />
          {/* <Route path="/docs/*" element={<DocsRedirect />} /> */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
